import { TableComment } from "../../../../general/src/TableComment";
import { SegAllocDetailTable } from "../../../../settlement/src/SegAllocDetailTable";
import { CurrentDispatchStops } from "../CurrentDispatchStops";
import { TableEquipmentAlerts } from "../TableEquipmentAlerts";
import { TableEquipmentIssued } from "../TableEquipmentIssued";
import { Button, CityState, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTractor extends Layout {
    buttonLocate: Button;
    buttonOpenClassic: Button;
    buttonTractorUsers: Button;
    citystateCityIdSearch: CityState;
    driver1FirstName: Textbox;
    driver1LastName: Textbox;
    horizSpacerTerminal: HorizontalSpacer;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacerComments: HorizontalSpacer;
    labelAssignedByInfo: Label;
    labelDriver1: Label;
    labelDriverTwoName: Label;
    labelMovementDistance: Label;
    labelMovementDistanceCaption: Label;
    labelMovementDistanceUm: Label;
    labelNoDispatchInfo: Label;
    labelOrder: Label;
    labelOrderId: Label;
    labelPreassignment: Label;
    labelPreassignmentCaption: Label;
    layoutCurrentDispatchStops: CurrentDispatchStops;
    layoutEquipmentIssued: TableEquipmentIssued;
    layoutImageTable: Layout;
    layoutSegAllocDetail: SegAllocDetailTable;
    layoutTableComment: TableComment;
    layoutTableEquipmentAlerts: TableEquipmentAlerts;
    panelAdditionalInfo: Panel;
    panelAssignedDriver: Panel;
    panelChecks: Panel;
    panelCurrentDispatchHeader: Panel;
    panelCurrentDispatchSearch: Panel;
    panelDataHeader: DataHeader;
    panelDispatchLineOne: Panel;
    panelDispatchLineThree: Panel;
    panelDispatchLineTwo: Panel;
    panelDriverOne: Panel;
    panelDriverOneName: Panel;
    panelDriverTwo: Panel;
    panelDriverTwoName: Panel;
    panelDrivers: Panel;
    panelFleet: Panel;
    panelGeneral1: Panel;
    panelGeneral2: Panel;
    panelGeneral3: Panel;
    panelGeneralDetail: Panel;
    panelGoals: Panel;
    panelHubDetail: Panel;
    panelInsurance: Panel;
    panelMaintenance: Panel;
    panelMake: Panel;
    panelMoveDistance: Panel;
    panelNoDispatchInformation: Panel;
    panelOrderId: Panel;
    panelPreassignment: Panel;
    panelSafetyDetail: Panel;
    panelSearchContent: Panel;
    panelStopDetailsSearch: Panel;
    panelTeamDriver: Panel;
    panelTopItems: Panel;
    panelTractorNumber: Panel;
    sourceAgencyLink: DataSource;
    sourceComments: DataSource;
    sourceEquipmentIssued: DataSource;
    sourceEquipmentTrackingHist: DataSource;
    sourceSegAllocDetail: DataSource;
    sourceTractor: DataSource;
    sourceUnitMessage: DataSource;
    switchExcludeFuelTax: Switch;
    switchExcludeTripMgt: Switch;
    switchInsured: Switch;
    switchLocal: Switch;
    switchPhantom: Switch;
    tabAllocation: Tab;
    tabComments: Tab;
    tabDispatch: Tab;
    tabEquipAlerts: Tab;
    tabEquipment: Tab;
    tabEquipmentTrackingHistory: Tab;
    tabGeneral: Tab;
    tabHub: Tab;
    tabImage: Tab;
    tabMaintenance: Tab;
    tabSafety: Tab;
    tableEquipmentTrackingHist: Table;
    tabsetDriver: Tabset;
    textDolly1Id: Textbox;
    textDolly2Id: Textbox;
    textId: Textbox;
    textTrailer2Id: Textbox;
    textTrailer3Id: Textbox;
    textTrailerId: Textbox;
    textboxAMaintHub: Textbox;
    textboxActualArrivalSearch: Textbox;
    textboxActualDepartureSearch: Textbox;
    textboxAddressSearch: Textbox;
    textboxBMaintHub: Textbox;
    textboxCurrentHub: Textbox;
    textboxCurrentSite: Textbox;
    textboxDailyDistGoal: Textbox;
    textboxDailyRevGoal: Textbox;
    textboxDispatcher: Textbox;
    textboxDriver1Id: Textbox;
    textboxDriver1Terminal: Textbox;
    textboxDriver2Id: Textbox;
    textboxDriver2Terminal: Textbox;
    textboxDriverTwoFirstName: Textbox;
    textboxDriverTwoLastName: Textbox;
    textboxFleetId: Textbox;
    textboxHubChangeDate: Textbox;
    textboxInserviceDate: Textbox;
    textboxInsuranceAmount: Textbox;
    textboxLastHomeDate: Textbox;
    textboxLastHomeDateTwo: Textbox;
    textboxLastInspectionDate: Textbox;
    textboxLastLocation: Textbox;
    textboxLiabilityEndDt: Textbox;
    textboxLiabilityStartDt: Textbox;
    textboxLocationNameSearch: Textbox;
    textboxMaintenanceDate: Textbox;
    textboxMake: Textbox;
    textboxModel: Textbox;
    textboxModelYear: Textbox;
    textboxNextHomeDate: Textbox;
    textboxNextHomeDateTwo: Textbox;
    textboxOutOfServiceDate: Textbox;
    textboxOwner: Textbox;
    textboxPayOwner: Textbox;
    textboxPlanningComment: Textbox;
    textboxPromiseDate: Textbox;
    textboxPtaDate: Textbox;
    textboxPtaDateTwo: Textbox;
    textboxPurchaseDate: Textbox;
    textboxSerialNumber: Textbox;
    textboxServiceStatus: Textbox;
    textboxState: Textbox;
    textboxTag: Textbox;
    textboxTagExpireDate: Textbox;
    textboxTypeOf: Textbox;
    textboxVideoSafetyControlId: Textbox;
    textboxWeight: Textbox;
    textboxWeightUm: Textbox;
    textboxWorkOrder: Textbox;
    textboxWorkOrderStatus: Textbox;
}
